import React from "react";
import ModalWrapper from "..";
import { ContentType } from "../../../constants/common";

interface ViewAttachmentModalProps {
  attachment: string;
  contentType?: string;
  isOpen: boolean;
  onOpenChange: () => void;
}

const ViewAttachmentModal = ({
  attachment,
  contentType,
  isOpen,
  onOpenChange,
}: ViewAttachmentModalProps) => {
  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      {contentType !== ContentType.PDF ? (
        <img src={attachment} alt="attachment" className="max-h-[70vh]" />
      ) : (
        <iframe
          title="attachment"
          src={attachment}
          width="100%"
          height="800px"
          className="max-h-[70vh]"
        />
      )}
    </ModalWrapper>
  );
};

export default React.memo(ViewAttachmentModal);
